import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ReportingService } from '../../../../services/reporting.service';

import { AngularCsv } from 'angular-csv-ext/dist/Angular-csv';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrManager } from 'ng6-toastr-notifications';
import { NetworkService } from '../../../../services/network.service';
import { environment } from '../../../../../environments/environment';
import { _ENDPOINT } from '../../../../endpoints/endpoint';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Utility } from '../../../../utility/utility';
import { SlaRespectedViewComponent } from '../sla-respected-view/sla-respected-view.component';

@Component({
  selector: 'app-order-detail',
  templateUrl: './order-detail.component.html',
  styleUrls: ['./order-detail.component.css']
})
export class OrderDetailComponent implements OnInit, OnDestroy {

  @Input() dropdownListBO: any[] = [];
  @Input() selectedItemsBO: any[] = [];
  @Input() dropdownListOrderCluster: any[] = [];
  @Input() selectedItemsOrderCluster: any[] = [];
  @Input() dropdownListCustomer: any[] = [];
  @Input() selectedItemsCustomer: any[] = [];
  @Input() dropdownListCountry: any[] = [];
  @Input() selectedItemsCountry: any[] = [];
  @Input() dropdownListMonth: any[] = [];
  @Input() selectedItemsMonth: any[] = [];
  @Input() dropdownListYear: any[] = [];
  @Input() selectedItemsYear: any[] = [];
  @Input() dropdownListOrderType: any[] = [];
  @Input() selectedItemsOrderType: any[] = [];
  @Input() customerOfCountry: Map<string, string[]>;
  @Input() orderTypeOfOrderCLuster: Map<string, string[]>;
  @Input() idLeadGlobalOfCustomerName: Map<string, string[]>;
  @Input() selectedItemsIdGlobal: any[] = [];
  @Input() dropdownListOrderStatus: any[] = [];
  @Input() selectedItemsOrderStatus: any[] = [];
  @Input() dropdownListLead: any[] = [];
  @Input() selectedItemsLead: any[] = [];


  @Output() loadReportEvent = new EventEmitter<any>();

  @Output() loadReportSelectedEvent = new EventEmitter<any>();

  @Input() listOrder: any[] = [];

  @Input() listOrderSelected: any[] = [];
  viewOrderStatus: boolean = true;
  viewMonth: boolean = true;



  settingsFilter = {
    actions: {
      add: false,
      edit: false,
      delete: false,
    },
    columns: {
      lead: {
        title: 'Lead Operator',
        filter: false
      },
      bmember: {
        title: 'B Operator',
        filter: false
      },
      orderId: {
        title: 'Order ID',
        filter: false,
        sort: false
      },
      orderStatus: {
        title: 'Order Status',
        filter: false
      },
      orderType: {
        title: 'Order Type',
        filter: false
      },
      startDate: {
        title: 'Order Creation Date',
        filter: false,
        compareFunction(direction: any, a: string, b: string) {

          let dateObjectA: any;
          let dateObjectB: any;
          if (a) {
            let datePartsA = a.split("/");
            let timePartsA = datePartsA[2].split(" - ")[1].split(":");
            datePartsA[2] = datePartsA[2].split(" - ")[0];
            dateObjectA = new Date(+datePartsA[2], +datePartsA[1] - 1, +datePartsA[0], +timePartsA[0], +timePartsA[1], +0);
            console.log(dateObjectA);
          }
          if (b && dateObjectA) {
            let datePartsB = b.split("/");
            let timePartsB = datePartsB[2].split(" - ")[1].split(":");
            datePartsB[2] = datePartsB[2].split(" - ")[0];
            dateObjectB = new Date(+datePartsB[2], +datePartsB[1] - 1, +datePartsB[0], +timePartsB[0], +timePartsB[1], +0);

            console.log(dateObjectB);
          }


          if (dateObjectA < dateObjectB) {
            return -1 * direction;
          }
          if (dateObjectA > dateObjectB) {
            return direction;
          }

          return 0;
        }
      },
      endDate: {
        title: 'Last Update',
        filter: false,
        compareFunction(direction: any, a: string, b: string) {

          let dateObjectA: any;
          let dateObjectB: any;
          if (a) {
            let datePartsA = a.split("/");
            let timePartsA = datePartsA[2].split(" - ")[1].split(":");
            datePartsA[2] = datePartsA[2].split(" - ")[0];
            dateObjectA = new Date(+datePartsA[2], +datePartsA[1] - 1, +datePartsA[0], +timePartsA[0], +timePartsA[1], +0);
            console.log(dateObjectA);
          }
          if (b && dateObjectA) {
            let datePartsB = b.split("/");
            let timePartsB = datePartsB[2].split(" - ")[1].split(":");
            datePartsB[2] = datePartsB[2].split(" - ")[0];
            dateObjectB = new Date(+datePartsB[2], +datePartsB[1] - 1, +datePartsB[0], +timePartsB[0], +timePartsB[1], +0);

            console.log(dateObjectB);
          }


          if (dateObjectA < dateObjectB) {
            return -1 * direction;
          }
          if (dateObjectA > dateObjectB) {
            return direction;
          }

          return 0;
        }
      },
      orderTimeWithoutDate: {
        title: 'Order Aging (HH:MM)',
        filter: false,
        compareFunction(direction: any, a: string, b: string) {
          let firstString: string[] = a.split(":");
          let secondString: string[] = b.split(":");
          let firstNeg: boolean = false;
          let secondNeg: boolean = false;
          if(firstString[0].startsWith("-")){
            firstNeg= true;
            firstString[0]=firstString[0].substring(1);
          }
          if(secondString[0].startsWith("-")){
            secondNeg= true;
            secondString[0]=secondString[0].substring(1);
          }
          let firstNumOfFirstString: string = firstString[0].startsWith("0") ? firstString[0].substring(1) : firstString[0];
          let secondNumOfFirstString: string = firstString[1].startsWith("0") ? firstString[1].substring(1) : firstString[1];
          let firstNumOfSecondString: string = secondString[0].startsWith("0") ? secondString[0].substring(1) : secondString[0];
          let secondNumOfSecondString: string = secondString[1].startsWith("0") ? secondString[1].substring(1) : secondString[1];

          let firstNumberOfFirstNum: number = +firstNumOfFirstString;
          let secondNumberOfFirstNum: number = +secondNumOfFirstString;
          let firstNumberOfSecondNum: number = +firstNumOfSecondString;
          let secondNumberOfSecondNum: number = +secondNumOfSecondString;
          let first:number=0;
          let second:number=0;
          if(firstNeg){
            first= ((firstNumberOfFirstNum*3600)+(secondNumberOfFirstNum*60))*(-1);
          }else{
            first= ((firstNumberOfFirstNum*3600)+(secondNumberOfFirstNum*60));
          }
          if(secondNeg){
            second= ((firstNumberOfSecondNum*3600)+(secondNumberOfSecondNum*60))*(-1);
          }else{
            second= ((firstNumberOfSecondNum*3600)+(secondNumberOfSecondNum*60));
          }
          if (first < second) {
            return -1 * direction;
          }
          if (first > second) {
            return direction;
          }
          return 0;
        }
      },
      sla: {
        title: 'SLA Value (HH:MM)',
        filter: false,
        compareFunction(direction: any, a: string, b: string) {
          let firstString: string[] = a.split(":");
          let secondString: string[] = b.split(":");
          let firstNeg: boolean = false;
          let secondNeg: boolean = false;
          if(firstString[0].startsWith("-")){
            firstNeg= true;
            firstString[0]=firstString[0].substring(1);
          }
          if(secondString[0].startsWith("-")){
            secondNeg= true;
            secondString[0]=secondString[0].substring(1);
          }


          let firstNumOfFirstString: string = firstString[0].startsWith("0") ? firstString[0].substring(1) : firstString[0];
          let secondNumOfFirstString: string = firstString[1].startsWith("0") ? firstString[1].substring(1) : firstString[1];
          let firstNumOfSecondString: string = secondString[0].startsWith("0") ? secondString[0].substring(1) : secondString[0];
          let secondNumOfSecondString: string = secondString[1].startsWith("0") ? secondString[1].substring(1) : secondString[1];

          let firstNumberOfFirstNum: number = +firstNumOfFirstString;
          let secondNumberOfFirstNum: number = +secondNumOfFirstString;
          let firstNumberOfSecondNum: number = +firstNumOfSecondString;
          let secondNumberOfSecondNum: number = +secondNumOfSecondString;
          let first:number=0;
          let second:number=0;
          if(firstNeg){
            first= ((firstNumberOfFirstNum*3600)+(secondNumberOfFirstNum*60))*(-1);
          }else{
            first= ((firstNumberOfFirstNum*3600)+(secondNumberOfFirstNum*60));
          }
          if(secondNeg){
            second= ((firstNumberOfSecondNum*3600)+(secondNumberOfSecondNum*60))*(-1);
          }else{
            second= ((firstNumberOfSecondNum*3600)+(secondNumberOfSecondNum*60));
          }
          if (first < second) {
            return -1 * direction;
          }
          if (first > second) {
            return direction;
          }
          return 0;
        }


      },
      slaDiff: {
        title: 'Delta SLA  (HH:MM)',
        filter: false,
        compareFunction(direction: any, a: string, b: string) {
          let firstString: string[] = a.split(":");
          let secondString: string[] = b.split(":");
          let firstNeg: boolean = false;
          let secondNeg: boolean = false;
          if(firstString[0].startsWith("-")){
            firstNeg= true;
            firstString[0]=firstString[0].substring(1);
          }
          if(secondString[0].startsWith("-")){
            secondNeg= true;
            secondString[0]=secondString[0].substring(1);
          }
          console.log("firstString[0]=",firstString[0]);

          console.log("secondString[0]=",secondString[0]);
          let firstNumOfFirstString: string = firstString[0].startsWith("0") ? firstString[0].substring(1) : firstString[0];
          let secondNumOfFirstString: string = firstString[1].startsWith("0") ? firstString[1].substring(1) : firstString[1];
          let firstNumOfSecondString: string = secondString[0].startsWith("0") ? secondString[0].substring(1) : secondString[0];
          let secondNumOfSecondString: string = secondString[1].startsWith("0") ? secondString[1].substring(1) : secondString[1];

          let firstNumberOfFirstNum: number = +firstNumOfFirstString;
          let secondNumberOfFirstNum: number = +secondNumOfFirstString;
          let firstNumberOfSecondNum: number = +firstNumOfSecondString;
          let secondNumberOfSecondNum: number = +secondNumOfSecondString;
          let first:number=0;
          let second:number=0;
          if(firstNeg){
            first= ((firstNumberOfFirstNum*3600)+(secondNumberOfFirstNum*60))*(-1);
          }else{
            first= ((firstNumberOfFirstNum*3600)+(secondNumberOfFirstNum*60));
          }
          if(secondNeg){
            second= ((firstNumberOfSecondNum*3600)+(secondNumberOfSecondNum*60))*(-1);
          }else{
            second= ((firstNumberOfSecondNum*3600)+(secondNumberOfSecondNum*60));
          }
          console.log("first=",+first);

          console.log("second=",+second);
          if (first < second) {
            return -1 * direction;
          }
          if (first > second) {
            return direction;
          }
          return 0;
        },
      },
      button: {
        title: 'SLA',
        filter: false,
        type: 'custom',
        renderComponent: SlaRespectedViewComponent,
        sort: false
      }


    },
    pager: {
      display: false
    }
  };

  destroy$ = new Subject<boolean>();
  responseExport: any;
  responseTendineInventory: any = {};

  constructor(private reportingService: ReportingService, private networkService: NetworkService, private toastr: ToastrManager,
    private spinner: NgxSpinnerService) {

  }

  ngOnInit(): void {
    if (!this.reportingService.orderDetailLoadedAlmostOneTime) {
      this.initTendineValue();
    } else {
      this.selectedItemsYear = this.reportingService.selectedItemsOrderDetail.selectedItemsYear;
      this.selectedItemsMonth = this.reportingService.selectedItemsOrderDetail.selectedItemsMonth;
      this.selectedItemsCountry = this.reportingService.selectedItemsOrderDetail.selectedItemsCountry;
      this.selectedItemsCustomer = this.reportingService.selectedItemsOrderDetail.selectedItemsCustomer;
      this.selectedItemsOrderType = this.reportingService.selectedItemsOrderDetail.selectedItemsOrderType;
      this.selectedItemsBO = this.reportingService.selectedItemsOrderDetail.selectedItemsBO;
      this.selectedItemsIdGlobal = this.reportingService.selectedItemsOrderDetail.selectedItemsIdGlobal;
      this.selectedItemsLead = this.reportingService.selectedItemsOrderDetail.selectedItemsLead;
      this.selectedItemsOrderStatus = this.reportingService.selectedItemsOrderDetail.selectedItemsOrderStatus;
      this.selectedItemsOrderCluster = this.reportingService.selectedItemsOrderDetail.selectedItemsOrderCluster;
      this.listOrder = this.reportingService.listOrderDetail;
    }


  }

  initTendineValue() {
    this.initOrderCluster();
    this.initBO();
    this.initCountry();
    this.initCustomer();
    this.initMonth();
    this.initYear();
    this.initOrderType();
    this.initOrderStatus();
    this.initLead();
    this.initCustomerIdGlobal();
    this.initReport();
  }

  initOrderCluster() {
    let arrayOrderCluster: any[] = [];
    if (this.dropdownListOrderCluster && this.dropdownListOrderCluster.length > 0) {
      for (let elem of this.dropdownListOrderCluster) {
        arrayOrderCluster.push(elem);
      }
    }
    this.selectedItemsOrderCluster = arrayOrderCluster;
  }

  initBO() {
    let arrayBO: any[] = [];
    if (this.dropdownListBO && this.dropdownListBO.length > 0) {
      for (let elem of this.dropdownListBO) {
        arrayBO.push(elem);
      }
    }
    this.selectedItemsBO = arrayBO;
  }

  initCountry() {
    let arrayCountry: any[] = [];
    if (this.dropdownListCountry && this.dropdownListCountry.length > 0) {
      for (let elem of this.dropdownListCountry) {
        arrayCountry.push(elem);
      }
    }
    this.selectedItemsCountry = arrayCountry;
  }

  initCustomer() {
    let arrayCustomer: any[] = [];
    if (this.dropdownListCustomer && this.dropdownListCustomer.length > 0) {
      for (let elem of this.dropdownListCustomer) {
        arrayCustomer.push(elem);
      }
    }
    this.selectedItemsCustomer = arrayCustomer;
  }

  initMonth() {
    let arrayMonth: any[] = [];
    if (this.dropdownListMonth && this.dropdownListMonth.length > 0) {
      for (let elem of this.dropdownListMonth) {
        arrayMonth.push(elem);
      }
    }
    this.selectedItemsMonth = arrayMonth;
  }

  initYear() {
    let arrayYear: any[] = [];
    if (this.dropdownListYear && this.dropdownListYear.length > 0) {
      for (let elem of this.dropdownListYear) {
        if (elem.item_id == this.getCurrentYear()) {
          arrayYear.push(elem);
        }
      }
    }
    this.selectedItemsYear = arrayYear;
  }

  initOrderType() {
    let arrayOrderType: any[] = [];
    if (this.dropdownListOrderType && this.dropdownListOrderType.length > 0) {
      for (let elem of this.dropdownListOrderType) {
        arrayOrderType.push(elem);
      }
    }
    this.selectedItemsOrderType = arrayOrderType;
  }

  loadReport(data: any) {
    this.loadReportEvent.emit(data);
  }

  loadReportSelected() {
    let data: any = {
      selectedItemsYear: this.selectedItemsYear,
      selectedItemsMonth: this.selectedItemsMonth,
      selectedItemsCountry: this.selectedItemsCountry,
      selectedItemsCustomer: this.selectedItemsCustomer,
      selectedItemsOrderType: this.selectedItemsOrderType,
      selectedItemsBO: this.selectedItemsBO,
      selectedItemsIdGlobal: this.selectedItemsIdGlobal,
      selectedItemsLead: this.selectedItemsLead,
      selectedItemsOrderStatus: this.selectedItemsOrderStatus,
      selectedItemsOrderCluster: this.selectedItemsOrderCluster
    };
    this.loadReportSelectedEvent.emit(data);
  }

  viewLoadMoreReport() {
    if (this.listOrder && this.listOrder.length > 24) {
      return true;
    } else {
      return false;
    }
  }

  initReport() {
    let data: any = {
      selectedItemsYear: this.selectedItemsYear,
      selectedItemsMonth: this.selectedItemsMonth,
      selectedItemsCountry: this.selectedItemsCountry,
      selectedItemsCustomer: this.selectedItemsCustomer,
      selectedItemsOrderType: this.selectedItemsOrderType,
      selectedItemsBO: this.selectedItemsBO,
      selectedItemsIdGlobal: this.selectedItemsIdGlobal,
      selectedItemsLead: this.selectedItemsLead,
      selectedItemsOrderStatus: this.selectedItemsOrderStatus,
      selectedItemsOrderCluster: this.selectedItemsOrderCluster
    }
    this.reportingService.setSelectedItemsOrderDetail(data);
    this.loadReportEvent.emit(data);
  }

  initCustomerIdGlobal() {
    let arrayIdGlobal: any[] = [];
    if (this.selectedItemsCustomer && this.selectedItemsCustomer.length > 0) {
      for (let elem of this.selectedItemsCustomer) {
        let key: string = elem.item_id;
        if (this.idLeadGlobalOfCustomerName) {
          let arrayIds = this.idLeadGlobalOfCustomerName.get(key);
          if (Array.isArray(arrayIds)) {
            for (let globalId of arrayIds) {
              let data: any = {
                item_id: globalId,
                item_text: globalId
              }
              let cust = arrayIdGlobal.find(x => x.item_id == data.item_id);
              if (!cust) {
                arrayIdGlobal.push(data);
              }

            }
          }
        }
      }
    }
    this.selectedItemsIdGlobal = arrayIdGlobal;
  }

  initOrderStatus() {
    let arrayOrderStatus: any[] = [];
    if (this.dropdownListOrderStatus && this.dropdownListOrderStatus.length > 0) {
      for (let elem of this.dropdownListOrderStatus) {
        arrayOrderStatus.push(elem);
      }
    }
    this.selectedItemsOrderStatus = arrayOrderStatus;
  }

  initLead() {
    let arrayLead: any[] = [];
    if (this.dropdownListLead && this.dropdownListLead.length > 0) {
      for (let elem of this.dropdownListLead) {
        arrayLead.push(elem);
      }
    }
    this.selectedItemsLead = arrayLead;
  }

  updateFilterEvent(event: any) {
    this.selectedItemsYear = event.selectedItemsYear;
    this.selectedItemsMonth = event.selectedItemsMonth;
    this.selectedItemsCountry = event.selectedItemsCountry;
    this.selectedItemsCustomer = event.selectedItemsCustomer;
    this.selectedItemsOrderType = event.selectedItemsOrderType;
    this.selectedItemsBO = event.selectedItemsBO;
    this.selectedItemsIdGlobal = event.selectedItemsIdGlobal;
    this.selectedItemsLead = event.selectedItemsLead;
    this.selectedItemsOrderStatus = event.selectedItemsOrderStatus;
    this.selectedItemsOrderCluster = event.selectedItemsOrderCluster;
    this.reportingService.setChangedFilterOrderDetail();
    this.reportingService.setSelectedItemsOrderDetail(event);
  }

  viexExportCsv() {
    if (this.listOrder && this.listOrder.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  getCurrentYear(): string {
    const currentYear = new Date().getFullYear();
    return String(currentYear);
  }

  exportAllItemsCsv() {

    this.spinner.show("sp1");
    let urlExport: string = environment.basePath + _ENDPOINT.exportCsvOrderDetail;
    let request = this.reportingService.selectedItemsOrderDetail;
    let data = Utility.createBodyForPostRequest(request, false);
    this.networkService.post(urlExport, data)
      .pipe(takeUntil(this.destroy$))
      .subscribe(response => {
        if (this.networkService.checkEnvironmentIsDev()) {
          if (response && response.statusCode == '200' && response.body && response.body.length > 0) {
            this.responseExport = JSON.parse(response.body);

            this.spinner.hide("sp1");
            this.downloadCsvFromPresignedUrl();
          } else if (response && response.statusCode == '500' && response.body && response.body.length > 0) {
            this.spinner.hide('sp1');
            this.toastr.errorToastr(response.body, 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          }
        } else {
          if (response && response.presignedUrl) {
            this.responseExport = response;
            this.spinner.hide("sp1");
            this.downloadCsvFromPresignedUrl();
          } else if (response && response.length && response.length > 0) {
            this.spinner.hide('sp1');
            console.log(response);
            this.toastr.errorToastr(response.toString(), 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          } else {
            this.spinner.hide('sp1');
            console.log(response);
            this.toastr.errorToastr('Error during export csv', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          }
        }
      },
        err => {
          this.spinner.hide("sp1");
          this.toastr.errorToastr('Error during export csv', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          console.error(err);
        });
  }

  downloadCsvFromPresignedUrl() {
    //this.fileService.downloadFile().subscribe(response => {
    this.networkService.downloadFile(this.responseExport.presignedUrl).subscribe((response: any) => { //when you use stricter type checking
      let blob: any = new Blob([response], { type: 'text/csv; charset=utf-8' });
      const url = window.URL.createObjectURL(blob);
      //window.open(url);
      let downloadLink = document.createElement("a");
      downloadLink.href = url;
      downloadLink.download = "OrdersDetailReport.csv";

      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      //}), error => console.log('Error downloading the file'),
    }), (error: any) => console.log('Error downloading the file', error), //when you use stricter type checking
      () => console.info('File downloaded successfully');
  }

  initializeTendine() {

    this.spinner.show("sp1");
    let urlTendineReporting: string = environment.basePath + _ENDPOINT.getTendineReporting;
    let data = {
      body: ''
    }
    this.networkService.post(urlTendineReporting, data)
      .pipe(takeUntil(this.destroy$))
      .subscribe(response => {
        if (this.networkService.checkEnvironmentIsDev()) {
          if (response && response.statusCode == '200' && response.body && response.body.length > 0) {
            this.responseTendineInventory = JSON.parse(response.body);
            this.initTendineCountryAndCustomer(this.responseTendineInventory);
            this.initTendine(this.responseTendineInventory);
            this.spinner.hide("sp1");

          } else if (response && response.statusCode == '500' && response.body && response.body.length > 0) {
            this.spinner.hide('sp1');
            this.toastr.errorToastr(response.body, 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          }
        } else {
          if (response && response.customerOfCountry) {
            this.responseTendineInventory = response;
            this.initTendineCountryAndCustomer(this.responseTendineInventory);
            this.initTendine(this.responseTendineInventory);
            this.spinner.hide("sp1");
          } else if (response && response.length && response.length > 0) {
            this.spinner.hide('sp1');
            console.log(response);
            this.toastr.errorToastr(response.toString(), 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          } else {
            this.spinner.hide('sp1');
            console.log(response);
            this.toastr.errorToastr('Error during selectItem reporting Retrieve', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          }
        }
      },
        err => {
          this.spinner.hide("sp1");
          this.toastr.errorToastr('Error during selectItem reporting Retrieve', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          console.error(err);
        });
  }

  initTendineCountryAndCustomer(responseTendineInventory: any) {
    if (responseTendineInventory && responseTendineInventory.customerOfCountry
      && responseTendineInventory.orderTypeOfOrderCLuster) {
      this.customerOfCountry = new Map(Object.entries(responseTendineInventory.customerOfCountry));
      this.orderTypeOfOrderCLuster = new Map(Object.entries(responseTendineInventory.orderTypeOfOrderCLuster));
      this.idLeadGlobalOfCustomerName = new Map(Object.entries(responseTendineInventory.idLeadGlobalOfCustomerName));
      this.initDropdownCountryCustomer();
    }
  }

  initDropdownCountryCustomer() {
    let country: any[] = [];
    let customer: any[] = [];
    for (let [key, value] of this.customerOfCountry) {
      let data = { item_id: key, item_text: key };
      if (country.indexOf(data) == -1) {
        country.push(data);
      }
      for (let elem of value) {
        let dataCustomer = { item_id: elem, item_text: elem };
        let cust = customer.find(x => x.item_id == dataCustomer.item_id);
        if (!cust) {
          customer.push(dataCustomer);
        }

      }
    }
    this.dropdownListCountry = country;
    this.dropdownListCustomer = customer;
  }

  initTendine(responseTendineInventory: any) {
    this.dropdownListBO = responseTendineInventory.dropdownListBO;
    this.dropdownListOrderCluster = responseTendineInventory.dropdownListOrderCluster;
    this.dropdownListMonth = responseTendineInventory.dropdownListMonth;
    this.dropdownListYear = responseTendineInventory.dropdownListYear;
    this.dropdownListOrderType = responseTendineInventory.dropdownListOrderType;
    this.dropdownListOrderStatus = responseTendineInventory.dropdownListOrderStatus;
    this.dropdownListLead = responseTendineInventory.dropdownListLead;
    this.initTendineValue();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
